import React from 'react';
import type { BadgeVariant } from '@shared/config/theme';
import { toneChipClasses } from '@shared/utils/statusTone';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

/**
 * Badge maps its variant vocabulary onto the shared tone contract so state
 * colors have exactly one definition (see `shared/config/theme.ts`).
 */
const variantToTone = {
  success: toneChipClasses.ok,
  warning: toneChipClasses.warn,
  error: toneChipClasses.danger,
  info: toneChipClasses.info,
  neutral: toneChipClasses.neutral,
} as const;

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'neutral', className = '' }) => {
  const baseStyles =
    'inline-flex min-h-6 items-center px-2.5 py-1 rounded-full text-xs font-semibold tracking-normal border';

  return <span className={`${baseStyles} ${variantToTone[variant]} ${className}`}>{children}</span>;
};
